"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageHeaders = exports.getMomentLocale = exports.getAngularLocale = exports.getUserLanguage = void 0;
var translations_1 = require("@shared/constants/translations");
var lodash_1 = __importDefault(require("lodash"));
// @ts-ignore
var getUserLanguage = function (user) {
    return user.language || translations_1.DEFAULT_LANGUAGE_CODE;
};
exports.getUserLanguage = getUserLanguage;
var getAngularLocale = function (languageCode) {
    var locale = lodash_1.default.get(translations_1.LANG_LOCALE_MAPPING, [languageCode, 'angularLocale'], languageCode);
    // languageCode must be lowercase to match filename in dist/static/translations
    return locale.toLowerCase();
};
exports.getAngularLocale = getAngularLocale;
var getMomentLocale = function (languageCode) {
    var locale = lodash_1.default.get(translations_1.LANG_LOCALE_MAPPING, [languageCode, 'momentLocale'], translations_1.DEFAULT_LANGUAGE_CODE);
    return locale.toLowerCase();
};
exports.getMomentLocale = getMomentLocale;
var getLanguageHeaders = function (language) {
    return {
        headers: {
            'Content-Language': language
        }
    };
};
exports.getLanguageHeaders = getLanguageHeaders;
